export default function UnderConstruction() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 bg-foreground-500/10 border border-foreground-500/20">
        <i className="ri-tools-line text-3xl text-foreground-600" />
      </div>
      <h3 className="text-xl font-semibold text-white mb-2">Раздел в разработке</h3>
      <p className="text-foreground-500 text-sm max-w-md leading-relaxed">
        Мы готовим этот раздел. Он появится в ближайшее время — следите за обновлениями
        или уточните детали у своего менеджера.
      </p>
    </div>
  );
}
